<template>
  <v-container fluid>
    <v-row justify="center" v-if="geoLocationEnabled" no-gutters>
      <v-col sm="12" lg="12" md="12">
        <v-card class="elevation-0 finder-surface" color="transparent" flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" xl="2" lg="2" md="12" sm="12" class="b-wise-blue-background finder-nav">
                <div>
                  <!-- <v-img height="100" contain src="@/assets/img/home_bg.jpg"></v-img> -->
                  <div class="my-1">
                    <span style="color: #3d80e8; font-weight: 700; letter-spacing: 1px;" class="text-xl-h5 text-h6"
                      >SERVICES</span
                    >
                  </div>
                  <v-row v-if="categories && categories.records" class="mt-3" no-gutters>
                    <v-col v-for="(category, index) in parentCategories" :key="index" cols="12">
                      <v-card
                        :color="activeCategory === category.id ? '#eba614' : '#3d80e8'"
                        class="d-flex justify-space-between white--text pa-3 mt-3 align-center menu-button bottom-elevation"
                        @click="updateActiveCategory(category.id)"
                      >
                        <h4 v-if="categoryChildren(category.id).length > 0" class="white--text thin">
                          {{ category.name }}
                        </h4>
                        <h4 v-else class="white--text thin">{{ category.name }} ({{ category.locationCount }})</h4>
                        <v-icon
                          v-if="categoryChildren(category.id).length > 0 && activeParent === category.id"
                          small
                          color="white"
                        >
                          mdi-arrow-up
                        </v-icon>
                        <v-icon v-else-if="categoryChildren(category.id).length > 0" small class="ml-5" color="white">
                          mdi-arrow-down
                        </v-icon>
                      </v-card>
                      <v-card
                        v-for="(childCategory, childIndex) in categoryChildren(category.id)"
                        v-show="childCategory.parent === activeParent"
                        :key="childIndex"
                        flat
                        :color="activeCategory === childCategory.id ? '#eba614' : '#eaf1fd'"
                        class="font-left px-3 py-2 mt-1 ml-4 menu-button child-menu-button"
                        :class="{ 'child-menu-button--active': activeCategory === childCategory.id }"
                        @click="updateActiveCategory(childCategory.id)"
                      >
                        <h4 class="thin" :class="activeCategory === childCategory.id ? 'white--text' : 'child-menu-text'">
                          {{ childCategory.name }} ({{ childCategory.locationCount }})
                        </h4>
                      </v-card>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-card
                        :color="'#22a06b'"
                        class="d-flex justify-space-between white--text pa-3 mt-1 align-center menu-button"
                        :href="'https://api.whatsapp.com/send?phone=27781680192'"
                        :target="'_blank'"
                      >
                        <h3 class="white--text thin ">Talk to Somebody</h3>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12" xl="7" lg="7" md="12" sm="12">
                <!-- <v-toolbar style="position:absolute; z-index: 1; top:10%" flat color="transparent">
                  <v-btn color="#ee4137" dark class="mx-2">Youth-friendly & PrEP-providing clinics</v-btn>
                  <v-btn color="#ee4137" dark class="mx-2">Youth-friendly & PrEP-providing clinics</v-btn>
                  <v-btn color="#ee4137" dark class="mx-2">Youth-friendly & PrEP-providing clinics</v-btn>
                  <v-btn color="#ee4137" dark class="mx-2">Youth-friendly & PrEP-providing clinics</v-btn>
                </v-toolbar> -->
                <base-loader :is-loading="categoriesLoading" />
                <local-map :locationsArr="locationsArr" @newLocation="updatedPosition" @newZoom="updatedZoom" />
              </v-col>
              <v-col xl="3" lg="3" md="12" sm="12" cols="12">
                <v-row class="mt-0 finder-results" style="overflow-y: auto; max-height: 90vh">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12" v-if="activeCategory">
                        <h2 class="header--blue">{{ findCategoryById(activeCategory).name }}</h2>
                      </v-col>
                      <v-col cols="12" v-else>
                        <h2 class="header--blue">Facilities near to you</h2>
                      </v-col>
                    </v-row>
                    <v-row v-if="userID && userEmailAddress && userFirstName && userLastName">
                      <v-col>
                        <h4>Signed in as: {{ userFirstName }} {{ userLastName }} ({{ userEmailAddress }})</h4>
                        <h4 @click="clearLocalStorage" class="blue--text clickable">(Sign out)</h4>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col class="d-flex align-center">
                        <h4>Sign in:</h4>
                        <v-icon class="ml-5" color="blue darken-2" @click="loginViaGoogle">
                          mdi-google
                        </v-icon>
                        <v-icon class="ml-5" color="blue darken-2" @click="loginViaTwitter">
                          mdi-twitter
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-if="isLoading || categoriesLoading"
                    class="d-flex flex-column align-center justify-center"
                    cols="12"
                  >
                    <v-progress-circular size="50" indeterminate color="primary"></v-progress-circular>
                  </v-col>
                  <v-col v-else-if="locationsArr && locationsArr.length > 0" cols="12">
                    <v-card
                      v-for="(location, index) in locationsArr"
                      :key="index"
                      color="#fff"
                      class="elevation-6 mx-auto my-2 side-card"
                      style="z-index: 0"
                    >
                      <v-card-title class="smallerline mb-n2"
                        ><span class="smaller-heading" style="color:#3d80e8">{{ location.name }}</span></v-card-title
                      >
                      <v-card-text class="font-left">
                        <h4 v-if="false">Service Type</h4>
                        <!-- {{ location.serviceType }} -->
                        <h4>Address</h4>
                        {{ location.fullAddress }}
                        <div
                          v-html="
                            $options.filters.getMapsLink([
                              location.location.coordinates[0],
                              location.location.coordinates[1],
                              longitude,
                              latitude,
                            ])
                          "
                        ></div>
                        <h4 v-if="location && (location.telephoneNumber || location.emailAddress)">
                          Contact Information
                        </h4>
                        <div v-if="location.telephoneNumber">
                          Telephone Number:
                          <a target="_blank" :href="`tel:${location.telephoneNumber}`">{{
                            location.telephoneNumber
                          }}</a>
                        </div>
                        <div style="z-index: 5;" v-if="location.emailAddress">
                          Email Address:
                          <a target="_blank" :href="`mailto:${location.emailAddress}`">{{ location.emailAddress }}</a>
                        </div>
                        <h4>Rating</h4>
                        <div class="d-flex align-center">
                          <span
                            ><v-rating
                              class="mx-n3 my-n1"
                              background-color="orange lighten-3"
                              color="orange"
                              :value="Math.round(parseFloat(location.averageRating))"
                              readonly
                            ></v-rating
                          ></span>
                          <span class="ml-5"> ({{ location.averageRating.toFixed(2) }})</span>
                        </div>
                        <div class="d-flex align-center">
                          <span class="blue--text clickable" @click="openReviews(location.id)">
                            {{ location.ratingsCount }} {{ location.ratingsCount === 1 ? `Review` : `Reviews` }}</span
                          >
                          <v-spacer></v-spacer>
                          <span v-if="userID" class="orange--text clickable" @click="openCreateReview(location.id)">
                            Create your own review for this location</span
                          >
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col v-else cols="12">
                    <v-card color="#fff" class="mx-auto my-n2">
                      <v-alert color="primary" dark>
                        Please select a category to view facilities near you.
                      </v-alert>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" class="d-flex flex-column justify-center align-center mt-10">
        <h2 class="white--text">
          This Application Requires You to Have Location Services Enabled.
        </h2>
        <h3 class="gray--text">
          Enable location services and refresh the page.
        </h3>
      </v-col>
    </v-row>
    <v-dialog v-model="locationReviewsDialog" max-width="800px">
      <v-card>
        <v-card-title class="white--text" style="background-color: #3d80e8;">
          <span class="text-h5">Location Information</span>
          <!-- <v-spacer></v-spacer>
          <v-btn color="secondary" @click="openCreateReview()">
            Review this Location
          </v-btn> -->
        </v-card-title>

        <v-card-text class="font-left mt-5 " v-if="currentLocation">
          <h2 class="my-2" style="color:#3d80e8;">{{ currentLocation.name }}</h2>

          <h4>Address</h4>
          {{ currentLocation.fullAddress }}
          <td
            v-html="
              $options.filters.getMapsLink([
                currentLocation.location.coordinates[0],
                currentLocation.location.coordinates[1],
                longitude,
                latitude,
              ])
            "
          ></td>
          <h4 v-if="currentLocation && (currentLocation.telephoneNumber || currentLocation.emailAddress)">
            Contact Information
          </h4>
          <div v-if="currentLocation.telephoneNumber">
            Telephone Number:
            <a target="_blank" :href="`tel:${currentLocation.telephoneNumber}`">{{
              currentLocation.telephoneNumber
            }}</a>
          </div>
          <div v-if="currentLocation.emailAddress">
            Email Address:
            <a target="_blank" :href="`mailto:${currentLocation.emailAddress}`">{{ currentLocation.emailAddress }}</a>
          </div>
          <h4>Rating</h4>
          <div class="d-flex align-center">
            <span
              ><v-rating
                class="mx-n3 my-n1"
                background-color="orange lighten-3"
                color="orange"
                :value="Math.round(parseFloat(currentLocation.averageRating))"
                readonly
              ></v-rating
            ></span>
            <span class="ml-5"> ({{ currentLocation.averageRating.toFixed(2) }})</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
          <h2 class="my-2 ml-1" style="color:#3d80e8;">Reviews</h2>
          <v-row>
            <v-col v-if="ratings && ratings.records && ratings.records.length > 0">
              <v-card v-for="(review, index) in ratings.records" :key="index" class="elevation-6 mx-auto mb-1 pa-1">
                <v-card-title>
                  {{ review.createdByName }}
                </v-card-title>
                <v-card-text class="d-flex">
                  <div class="d-flex flex-column">
                    <div>
                      {{ review.comment }}
                    </div>
                    <div class="text-caption purple--text">{{ review.createdAt | getFormattedDate }}</div>
                  </div>

                  <v-spacer></v-spacer>
                  <v-divider vertical></v-divider>
                  <div class="pl-2">
                    <span>Friendliness:</span>
                    <v-rating
                      background-color="orange lighten-3"
                      color="orange"
                      small
                      readonly
                      :value="review.friendlinessValue"
                    ></v-rating>
                    <span>Waiting Time:</span>
                    <v-rating
                      background-color="orange lighten-3"
                      color="orange"
                      small
                      readonly
                      :value="review.waitingTimeValue"
                    ></v-rating>
                    <span>Privacy:</span>
                    <v-rating
                      background-color="orange lighten-3"
                      color="orange"
                      small
                      readonly
                      :value="review.privacyValue"
                    ></v-rating>
                  </div>
                </v-card-text>
                <v-card-text> </v-card-text>
              </v-card>
              <!-- <base-serial-number-details serial="currentInventoryItem" /> -->
            </v-col>
            <v-col v-else>
              <v-alert color="primary" dark>
                There are no reviews for this location.
              </v-alert>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="locationReviewsDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="createReviewDialog" max-width="800px">
      <v-card>
        <v-card-title class="white--text" style="background-color: #3d80e8;">
          <span class="text-h5">Create Review</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-container class="mt-10">
            <v-row>
              <v-col>
                <v-card flat>
                  <v-row class="d-flex align-center ">
                    <v-col cols="3">
                      <span class="text-h6">Comments:</span>
                    </v-col>
                    <v-col class="ml-3">
                      <v-textarea
                        v-model="review.comment"
                        label="Comments about this location "
                        required
                        outlined
                        :rules="[v => !!v || 'Comment is required']"
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row class="d-flex align-center ">
                    <v-col cols="3">
                      <span class="text-h6">Friendliness:</span>
                    </v-col>
                    <v-col>
                      <v-rating
                        v-model="review.friendlinessValue"
                        background-color="orange lighten-3"
                        color="orange"
                        :value="1"
                        hover
                      ></v-rating>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row class="d-flex align-center ">
                    <v-col cols="3">
                      <span class="text-h6">Waiting Time:</span>
                    </v-col>
                    <v-col>
                      <v-rating
                        v-model="review.waitingTimeValue"
                        background-color="orange lighten-3"
                        color="orange"
                        :value="1"
                        hover
                      ></v-rating>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row class="d-flex align-center ">
                    <v-col cols="3">
                      <span class="text-h6">Privacy:</span>
                    </v-col>
                    <v-col>
                      <v-rating
                        v-model="review.privacyValue"
                        background-color="orange lighten-3"
                        color="orange"
                        :value="1"
                        hover
                      ></v-rating>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="
              createReview(review);
              createReviewDialog = false;
            "
          >
            Save
          </v-btn>
          <v-btn color="secondary" @click="createReviewDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { gql } from 'apollo-boost';
import { User } from '@/models/User';
import mapstyle from '@/assets/js/mapstyle';
import { getAuth, signInWithPopup, GoogleAuthProvider, TwitterAuthProvider } from 'firebase/auth';
import { CompatSource } from 'webpack-sources';

const DEFAULT_MAP_CENTER = {
  latitude: -26.2041,
  longitude: 28.0473,
};

const LocalMap = {
  name: 'LocalMap',
  props: {
    locationsArr: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data: () => ({
    latitude: 0,
    longitude: 0,
    zoom: 12,
    map: null,
    mymarker: null,
    currentMarkers: [],
    isMapReady: false,
    initTimerId: null,
  }),
  created() {
    const self = this;
    self.initTimerId = setTimeout(() => {
      if (!self.map) {
        self.latitude = DEFAULT_MAP_CENTER.latitude;
        self.longitude = DEFAULT_MAP_CENTER.longitude;
        self.refreshMap();
      }
    }, 1200);

    if (typeof navigator !== 'undefined' && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          if (self.initTimerId) {
            clearTimeout(self.initTimerId);
            self.initTimerId = null;
          }
          self.latitude = position.coords.latitude;
          self.longitude = position.coords.longitude;
          if (self.map) {
            const newLatlng = { lat: self.latitude, lng: self.longitude };
            self.map.setCenter(newLatlng);
            if (self.mymarker) self.mymarker.setPosition(newLatlng);
          } else {
            self.refreshMap();
          }
        },
        () => {
          if (self.initTimerId) {
            clearTimeout(self.initTimerId);
            self.initTimerId = null;
          }
          if (!self.map) {
            self.latitude = DEFAULT_MAP_CENTER.latitude;
            self.longitude = DEFAULT_MAP_CENTER.longitude;
            self.refreshMap();
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      if (self.initTimerId) {
        clearTimeout(self.initTimerId);
        self.initTimerId = null;
      }
      if (!self.map) {
        self.latitude = DEFAULT_MAP_CENTER.latitude;
        self.longitude = DEFAULT_MAP_CENTER.longitude;
        self.refreshMap();
      }
    }
  },
  beforeDestroy() {
    if (this.initTimerId) {
      clearTimeout(this.initTimerId);
      this.initTimerId = null;
    }
  },
  watch: {
    locationsArr(newValue, oldValue) {
      const self = this;
      if (newValue && newValue.length > 0) {
        self.refreshMarkers();
      } else if (newValue && newValue.length === 0) {
        this.clearMarkers();
      }
    },
  },
  methods: {
    clearMarkers() {
      const self = this;
      for (var i = 0; i < this.currentMarkers.length; i++) {
        self.currentMarkers[i].setMap(null);
      } // Adding this here to clear all existing markers
      self.currentMarkers = [];
    },
    refreshMarkers() {
      const self = this;
      if (!(self.map && typeof window !== 'undefined' && window.google && window.google.maps)) return;

      if (self.locationsArr && self.locationsArr.length > 0) {
        console.time('Refreshing markers');
        for (var i = 0; i < this.currentMarkers.length; i++) {
          self.currentMarkers[i].setMap(null);
        } // Adding this here to clear all existing markers
        self.currentMarkers = [];
        function infoCallback(infowindow, marker) {
          return function() {
            infowindow.open(self.map, marker);
          };
        }
        function infoCallbackClose(infowindow, marker) {
          return function() {
            infowindow.close(self.map, marker);
          };
        }
        function openInfo(location) {
          return function() {
            self.showLocation(location);
          };
        }
        for (var i = 0; i < self.locationsArr.length; i++) {
          var location = self.locationsArr[i];
          var marker = new google.maps.Marker({
            position: { lat: location.location.coordinates[1], lng: location.location.coordinates[0] },
            map: self.map,
            animation: google.maps.Animation.FADE,
            icon: {
              url: require('../../assets/img/location-32x32.png'),
              labelOrigin: new google.maps.Point(85, 32),
              size: new google.maps.Size(32, 32),
              anchor: new google.maps.Point(20, 32),
            },
            // label: {
            //   text: location.name,
            //   color: '#eb3a44',
            //   fontSize: '8px',
            //   fontWeight: 'bold',
            // },
          });
          const contentString = `<div>
            <h4>${location.name}</h4>
            <div class="">${location.description}</div>
          </div>`;
          var infowindow = new google.maps.InfoWindow({ content: contentString });
          // infowindow.setContent(contentString);
          google.maps.event.addListener(marker, 'mouseover', infoCallback(infowindow, marker));
          google.maps.event.addListener(marker, 'mouseout', infoCallbackClose(infowindow, marker));
          google.maps.event.addListener(marker, 'click', openInfo(location));

          self.currentMarkers.push(marker); //I'm only adding the markers to an array to keep a reference so that i can eventually clear them.

          //   google.maps.event.addListener(
          //     marker,
          //     'click',
          //     (function(marker, i, infowindow) {
          //       return function() {
          //         console.log('Klick! Marker=' + this.content);
          //         infowindow.setContent(this.content);
          //         infowindow.open(self.map, this);
          //       };
          //     })(marker, i, infowindow)
          //   );
          // }
        }
        console.timeEnd('Refreshing markers');
      }
    },
    showLocation(location) {
      console.log('opening information dialog for', location.id);
      this.$parent.$parent.openReviews(location.id);
    },
    refreshMap() {
      const self = this;
      if (!(typeof window !== 'undefined' && window.google && window.google.maps)) {
        console.warn('Google Maps JavaScript not loaded or blocked. Skipping map init.');
        self.isMapReady = true;
        return;
      }

      let initialLatlng = { lat: self.latitude, lng: self.longitude };
      // Options
      let mapOptions = {
        center: initialLatlng,
        zoom: self.zoom,
        styles: mapstyle,
        fullscreenControl: true,
      };

      // Apply options
      self.map = new google.maps.Map(document.getElementById('map'), mapOptions);
      self.geocoder = new google.maps.Geocoder();
      self.infowindow = new google.maps.InfoWindow();
      google.maps.event.addListenerOnce(self.map, 'tilesloaded', function() {
        self.isMapReady = true;
      });
      // Create search bar autocomplete
      self.autocomplete = new google.maps.places.Autocomplete(
        self.$refs.input,
        Object.assign({
          componentRestrictions: { country: ['za'] },
          types: [],
        })
      );
      self.autocomplete.setFields(['geometry', 'formatted_address', 'name']);

      self.autocomplete.addListener('place_changed', self.moveMarker);
      // Add marker
      self.mymarker = new google.maps.Marker({
        position: initialLatlng,
        map: self.map,
      });
      // self.map.addListener("dragend", async (e) => {
      //   let lat = self.map.getCenter().lat();
      //   let lng = self.map.getCenter().lng();
      //   let newLgnLat = { lat: lat, lng: lng };
      //   const reversePlace = await self.reverseGeoCode(newLgnLat);
      //   self.setMarkerandEmit(newLgnLat, reversePlace);
      // });

      // self.map.addListener("center_changed", async (e) => {
      //   let lat = self.map.getCenter().lat();
      //   let lng = self.map.getCenter().lng();
      //   let newLgnLat = { lat: lat, lng: lng };
      //   self.mymarker.setPosition(newLgnLat);
      // });
      self.map.addListener('zoom_changed', async e => {
        let zoom = self.map.getZoom();
        self.$emit('newZoom', zoom);
      });
      self.refreshMarkers();
      google.maps.event.trigger(self.map, 'resize');
    },
    moveMarker() {
      var place = this.autocomplete.getPlace();
      var locationObject = place.geometry && place.geometry.location;
      if (locationObject) {
        let newLgnLat = {
          lat: locationObject.lat(),
          lng: locationObject.lng(),
        };
        this.map.panTo(newLgnLat);
        this.setMarkerandEmit(newLgnLat, place);
      }
    },
    setMarkerandEmit(location, place) {
      const self = this;
      self.place = place;
      self.mymarker.setPosition(location);
      // self.infowindow.setContent(place.formatted_address);
      // self.infowindow.open(self.map, self.mymarker);
      self.$refs.input.value = place.formatted_address;
      self.$emit('newLocation', {
        ...location,
        ...self.place,
      });
    },
    async reverseGeoCode(latlng) {
      const self = this;
      return new Promise((resolve, reject) => {
        self.geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === 'OK') {
            resolve(results[0]);
          } else {
            reject(status);
          }
        });
      });
    },
  },
  render() {
    const self = this;
    return (
      <div>
        <div id="latlng-picker" class="latlng-picker">
          <div class="latlng-picker__map">
            <div id="map"></div>
            {!self.isMapReady && (
              <div class="map-overlay">
                <div class="map-spinner"></div>
              </div>
            )}
            {self.isMapReady && (
              <div class="instruction-box fade-in" ref="instructions">
                <ol>
                  <li>Select the service you are looking for.</li>
                  <li>Input your location above to find the services closest to you.</li>
                </ol>
              </div>
            )}
            <input
              type="text"
              class={`latlng-picker__autocomplete ${self.isMapReady ? 'visible fade-in' : ''}`}
              ref="input"
              placeholder="Type in your location here"
            />
          </div>
        </div>
      </div>
    );
  },
};

export default {
  name: 'SearchSerials',
  components: {
    LocalMap,
  },
  data: () => ({
    step: 0,
    userID: '',
    userEmailAddress: '',
    userFirstName: '',
    userLastName: '',
    searchQuery: '',
    categoryQuery: '',
    activeCategory: '',
    activeParent: '',
    expand2: true,
    locationReviewsDialog: false,
    createReviewDialog: false,
    locationQuery: '',
    latitude: 0,
    longitude: 0,
    alreadyZoomed: [],
    zoom: 12,
    limit: 50,
    skip: 0,
    review: {
      location: null,
      comment: '',
      friendlinessValue: 1,
      waitingTimeValue: 1,
      privacyValue: 1,
    },
    locations: null,
    locationsArr: [],
    categoriesLoading: true,
    geoLocationEnabled: true,
    isLoading: false,
  }),
  created() {
    const self = this;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          self.geoLocationEnabled = true;
          self.latitude = position.coords.latitude;
          self.longitude = position.coords.longitude;
        },
        () => {
          self.geoLocationEnabled = false;
          // alert('The geolocation service failed."');
        },
        {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    } else {
      // Browser doesn't support Geolocation
      self.geoLocationEnabled = false;
      // alert('Your browser does not support geolocation');
    }
    this.userID = localStorage.getItem('userID') ? JSON.parse(localStorage.getItem('userID')) : '';
    this.userEmailAddress = localStorage.getItem('userEmailAddress')
      ? JSON.parse(localStorage.getItem('userEmailAddress'))
      : '';
    this.userFirstName = localStorage.getItem('userFirstName') ? JSON.parse(localStorage.getItem('userFirstName')) : '';
    this.userLastName = localStorage.getItem('userLastName') ? JSON.parse(localStorage.getItem('userLastName')) : '';
  },
  watch: {
    categories(newValue, oldValue) {
      if (newValue && newValue.records.length > 0) {
        var initialCategory = this.$route.query.category;
        if (initialCategory) {
          //If you pass in an initial category as the query parameter
          console.log('initialCategory', initialCategory);
          var category = newValue.records.find(category => category.id === initialCategory);
          if (category) {
            this.activeCategory = category.id;
            this.activeParent = category.parent;
            this.updateActiveCategory(initialCategory);
          }
        }
      }
    },
  },
  computed: {
    currentLocation() {
      const self = this;
      if (this.locationsArr && this.locationsArr.length > 0 && this.locationQuery) {
        return this.locationsArr.find(o => o.id === self.locationQuery);
      }
      return null;
    },
    parentCategories() {
      if (this.categories && this.categories.records && this.categories.records.length) {
        var parentCategories = this.categories.records.filter(category => !category.parent);
        for (var i = 0; i < parentCategories.length; i++) {
          let category = parentCategories[i];
          if (!category.priority) {
            category.priority = 0;
          }
        }
        // sort by priority descending
        parentCategories.sort((a, b) => b.priority - a.priority);
        console.log(parentCategories);
        return parentCategories;
      }
      return [];
    },
    isChildOfParent(parentCategory, childOfParent) {
      if (this.categories && this.categories.records && this.categories.records.length) {
        return this.categories.records.filter(category => !category.parent);
      }
      return [];
    },
  },
  apollo: {
    categories: {
      query: gql`
        query Categories($limit: Int!, $skip: Int!, $query: JSON!) {
          categories(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              parent
              priority
              locationCount
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      fetchPolicy: 'network-only',
      variables() {
        const self = this;
        const limit = 9999;
        const skip = 0;
        return {
          limit: limit,
          skip: skip,
          query: {},
        };
      },
      watchLoading(isLoading, countModifier) {
        this.categoriesLoading = isLoading;
      },
    },
    locations: {
      query: gql`
        query Locations($limit: Int!, $skip: Int!, $query: JSON!) {
          locations(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              description
              location
              serviceType
              fullAddress
              telephoneNumber
              emailAddress
              ratingsCount
              averageRating
            }
            count
          }
        }
      `,
      skip() {
        if (!this.longitude || !this.latitude) return true;
        return false;
      },
      fetchPolicy: 'network-only',
      variables() {
        const self = this;
        const limit = this.limit;
        const skip = this.skip;
        const searchQuery = this.searchQuery;
        const categoryQuery = this.categoryQuery;
        return {
          limit: limit,
          skip: skip,
          query: { categoryQuery: categoryQuery, longitude: self.longitude, latitude: self.latitude },
        };
      },
      result(result, key) {
        const { data, loading, errors } = result;
        console.log('yeah data appeared', data);
        if (loading) return;
        if (!(data && data.locations)) {
          console.warn('Locations query completed without data.', { data, errors, key });
          this.totalRecords = 0;
          return;
        }
        this.locationsArr = [...data.locations.records, ...this.locationsArr];
        // this.locationsArr = data.locations.records;
        console.log('locationsArr length', this.locationsArr.length);
        this.totalRecords = data.locations.count;
      },
      error(error) {
        console.error('Locations query failed.', error);
        this.totalRecords = 0;
        this.isLoading = false;
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
    ratings: {
      query: gql`
        query($limit: Int!, $skip: Int!, $query: JSON!) {
          ratings(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              comment
              friendlinessValue
              waitingTimeValue
              privacyValue
              createdByName
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      skip() {
        return !this.locationQuery;
      },
      variables() {
        const self = this;
        const limit = 999999999;
        const skip = 0;
        const locationQuery = this.locationQuery;
        return {
          limit: limit,
          skip: skip,
          query: { location: locationQuery },
        };
      },
      result({ data }, key) {
        console.log('yeah ratings data appeared', data);
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },
  methods: {
    updatedPosition(position) {
      const self = this;
      console.log(position);
      self.longitude = position.lng;
      self.latitude = position.lat;
    },
    updatedZoom(zoom) {
      const self = this;
      console.log('zoom', zoom);
      //check if value is in Array
      console.log(!self.alreadyZoomed.indexOf(zoom) > -1);
      console.log('alreadyZoomed', self.alreadyZoomed);
      if (zoom < self.zoom && !self.alreadyZoomed.indexOf(zoom) > -1) {
        self.alreadyZoomed.push(zoom);
        self.skip += 25;
      }
      self.zoom = zoom;
    },
    categoryChildren(categoryId) {
      if (this.categories && this.categories.records && this.categories.records.length) {
        var categories = this.categories.records.filter(category => category.parent === categoryId);
        for (var i = 0; i < categories.length; i++) {
          let category = categories[i];
          if (!category.priority) {
            category.priority = 0;
          }
        }
        categories.sort((a, b) => b.priority - a.priority);
        return categories;
      }
      return [];
    },
    findCategoryById(categoryId) {
      return this.categories.records.find(o => o.id === categoryId);
    },
    isParentCategoryWithChildren(categoryId) {
      return this.categoryChildren(categoryId).length > 0;
    },
    isParentCategory(categoryId) {
      return this.findCategoryById(categoryId).parent === null;
    },
    updateActiveCategory(categoryId) {
      console.log('Clicked category', categoryId);
      if (this.categoryChildren(categoryId).length === 0) {
        // no more children so do a search.
        console.log('Searching for category:', this.findCategoryById(categoryId));
        this.skip = 0;
        this.locationsArr = [];
        this.categoryQuery = categoryId;
      }
      if (this.isParentCategory(categoryId)) {
        // // click on a parent category
        console.log('active parent is changing');
        if (this.activeParent === categoryId) {
          this.activeParent = null;
        } else {
          this.activeParent = categoryId;
        }
      }
      this.activeCategory = categoryId;
    },
    openReviews(locationId) {
      this.locationQuery = locationId;
      console.log('Opening Reviews for:', locationId);
      this.locationReviewsDialog = true;
    },
    openCreateReview(locationId) {
      this.locationQuery = locationId;
      this.review.location = locationId;
      this.createReviewDialog = true;
    },
    generatePassword() {
      var length = 8,
        charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789',
        retVal = '';
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
    async findUserByEmailAddress(emailAddress) {
      const self = this;
      try {
        if (!emailAddress) {
          return null;
        }
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation findUserByEmailAddress($email: String!) {
              findUserByEmailAddress(email: $email) {
                id
              }
            }
          `,
          variables: {
            email: emailAddress,
          },
        });

        if (!response) {
          console.log('Something went wrong when finding the user by email!');
          return null;
        }
        if (response.errors && response.errors.length > 0) {
          console.log(response.errors[0]);
          return null;
        }
        if (response && response.data.findUserByEmailAddress) {
          console.log('Found user by email address', response.data.findUserByEmailAddress);
          return response.data.findUserByEmailAddress;
        }
      } catch (e) {
        console.log(e.message);
        return null;
      }
    },
    async createUser(userEmailAddress, userFirstName, userLastName) {
      const self = this;
      console.log('Creating new user', userEmailAddress, userFirstName, userLastName);
      try {
        if (!userEmailAddress || !userFirstName || !userLastName) {
          throw new Error('The correct details for this user need to be specified!');
        }
        console.log('Sufficient data to create new user', userEmailAddress, userFirstName, userLastName, {
          firstName: userFirstName,
          lastName: userLastName,
          email: userEmailAddress,
          password: self.generatePassword(),
          role: 'user',
        });
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createUser($user: UserCreateInput!) {
              createUser(user: $user) {
                id
                email
              }
            }
          `,
          variables: {
            user: {
              firstName: userFirstName,
              lastName: userLastName,
              email: userEmailAddress,
              password: self.generatePassword(),
              role: 'user',
            },
          },
        });
        console.log(response);
        if (!response) {
          throw new Error('Something went wrong when creating the User!');
        } else if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        } else if (response && response.data.createUser) {
          return response.data.createUser;
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createReview(review) {
      const self = this;
      const { location, comment, friendlinessValue, waitingTimeValue, privacyValue } = review;
      try {
        if (!self.userID || !location || !comment || !friendlinessValue || !waitingTimeValue || !privacyValue) {
          alert('The correct details for this review need to be specified!');
          return;
        }
        review.createdBy = self.userID;
        review.createdBy = self.userID;
        console.log('Creating Review', review);
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createRating($rating: RatingCreateInput!) {
              createRating(rating: $rating) {
                id
                location
              }
            }
          `,
          variables: {
            rating: review,
          },
        });

        if (!response) {
          throw 'Something went wrong when creating the Rating!';
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createRating) {
          this.$swal('Success!', 'Review was created', 'success');
          this.locationsArr = [];
          this.$apollo.queries.locations.refetch();
          this.$apollo.queries.ratings.refetch();
          return response.data.createRating;
        }
      } catch (e) {
        throw e.message;
      }
    },
    setLocalStorage(userID, userEmailAddress, userFirstName, userLastName) {
      localStorage.setItem('userID', JSON.stringify(userID));
      localStorage.setItem('userEmailAddress', JSON.stringify(userEmailAddress));
      localStorage.setItem('userFirstName', JSON.stringify(userFirstName));
      localStorage.setItem('userLastName', JSON.stringify(userLastName));
    },
    clearLocalStorage(userID, userEmailAddress, userFirstName, userLastName) {
      localStorage.removeItem('userID');
      localStorage.removeItem('userEmailAddress');
      localStorage.removeItem('userFirstName');
      localStorage.removeItem('userLastName');
      this.userID = '';
      this.userEmailAddress = '';
      this.userFirstName = '';
      this.userLastName = '';
      const auth = getAuth();
      auth
        .signOut()
        .then(() => {
          console.log('Signed Out');
        })
        .catch(e => {
          console.error('Sign Out Error', e);
        });
    },
    loginViaGoogle() {
      const self = this;
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
      try {
        signInWithPopup(auth, provider)
          .then(async result => {
            // This gives you a Google Access Token. You can use it to access the Google API.
            const credential = GoogleAuthProvider.credentialFromResult(result);
            const token = credential.accessToken;
            // The signed-in user info.
            const user = result.user;
            console.log('Google User', user);
            self.userEmailAddress = user.email;
            if (user.displayName && user.displayName.split(' ').length == 2) {
              self.userFirstName = user.displayName.split(' ')[0];
              self.userLastName = user.displayName.split(' ')[1];
            }
            var localUser = await self.findUserByEmailAddress(user.email);
            console.log(localUser);
            if (localUser) {
              console.log('Got a user which exists int he system already', localUser);
              self.userID = localUser.id;
            } else {
              try {
                var newLocalUser = await self.createUser(self.userEmailAddress, self.userFirstName, self.userLastName);
                console.log(newLocalUser);
                self.userID = newLocalUser.id;
              } catch (error) {
                console.log(error);
                self.$swal('Error!', `Something went wrong when trying to log you in.`, 'error');
              }
            }
            if (self.userID && self.userEmailAddress && self.userFirstName && self.userLastName) {
              self.setLocalStorage(self.userID, self.userEmailAddress, self.userFirstName, self.userLastName);
            }

            // ...
          })
          .catch(error => {
            // Handle Errors here.
            const errorCode = error.code;
            const errorMessage = error.message;
            // The email of the user's account used.
            const email = error.email;
            // The AuthCredential type that was used.
            const credential = GoogleAuthProvider.credentialFromError(error);
            // ...
          });
      } catch (error) {
        console.log(error);
      }
    },
    loginViaTwitter() {
      try {
        const self = this;
        const auth = getAuth();
        const provider = new TwitterAuthProvider();
        try {
          signInWithPopup(auth, provider)
            .then(async result => {
              console.log(result);
              // This gives you a Google Access Token. You can use it to access the Google API.
              const credential = TwitterAuthProvider.credentialFromResult(result);
              const token = credential.accessToken;
              // The signed-in user info.
              const user = result.user;
              console.log('Twitter User', user);
              self.userEmailAddress = user.email || user.providerData[0].email;
              if (user.displayName && user.displayName.split(' ').length == 2) {
                self.userFirstName = user.displayName.split(' ')[0];
                self.userLastName = user.displayName.split(' ')[1];
              }

              if (!self.userFirstName) {
                self.userFirstName = user.displayName;
              }

              if (!self.userLastName) {
                self.userLastName = 'None';
              }
              var localUser = await self.findUserByEmailAddress(self.userEmailAddress);
              console.log(localUser);
              if (localUser) {
                console.log('Got a user which exists int he system already', localUser);
                self.userID = localUser.id;
              } else {
                try {
                  var newLocalUser = await self.createUser(
                    self.userEmailAddress,
                    self.userFirstName,
                    self.userLastName
                  );
                  console.log(newLocalUser);
                  self.userID = newLocalUser.id;
                } catch (error) {
                  console.log(error);
                  self.$swal('Error!', `Something went wrong when trying to log you in.`, 'error');
                }
              }
              if (self.userID && self.userEmailAddress && self.userFirstName && self.userLastName) {
                self.setLocalStorage(self.userID, self.userEmailAddress, self.userFirstName, self.userLastName);
              }

              // ...
            })
            .catch(error => {
              console.log(error);
              console.log(error.code);
              console.log(error.message);
              // Handle Errors here.
              const errorCode = error.code;
              const errorMessage = error.message;
              // The email of the user's account used.
              const email = error.email;
              // The AuthCredential type that was used.
              const credential = TwitterAuthProvider.credentialFromError(error);
              // ...
            });
        } catch (error) {
          console.log(error);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="sass">


.latlng-picker
  min-height: 90vh

.latlng-picker__map
  position: relative
  width: 100%
  height: 100%
  border: 2px solid #3d80e8
  border-radius: 20px
  overflow: hidden
  box-shadow: 0 8px 24px rgba(61, 128, 232, 0.2)

#map
  width: 100%
  height: 100%

.map-overlay
  position: absolute
  top: 0
  left: 0
  right: 0
  bottom: 0
  display: flex
  align-items: center
  justify-content: center
  background: rgba(0, 0, 0, 0.1)
  z-index: 2

.map-spinner
  width: 56px
  height: 56px
  border: 6px solid rgba(255, 255, 255, 0.35)
  border-top-color: #3d80e8
  border-radius: 50%
  animation: spin 1s linear infinite

@keyframes spin
  to
    transform: rotate(360deg)

.latlng-picker__autocomplete
  position: absolute
  top: 12px
  left: 12px
  z-index: 3
  margin: 0px
  padding: 10px 20px
  width: 50%
  min-width: 100px
  font-family: 'Montserrat', sans-serif
  font-size: 18px
  font-weight: 400
  text-overflow: ellipsis
  border: 2px solid #3d80e8
  background-color: #fff
  border-radius: 50px
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18)
  opacity: 0
  pointer-events: none
  transition: opacity 300ms ease

.latlng-picker__autocomplete.visible
  opacity: 1
  pointer-events: auto

.fade-in
  opacity: 0
  animation: fadeIn 300ms ease forwards

@keyframes fadeIn
  from
    opacity: 0
  to
    opacity: 1

.instruction-box
  position: absolute
  top: 68px
  left: 12px
  z-index: 3
  margin: 0px
  padding: 14px 18px
  width: 50%
  min-width: 100px
  font-family: 'Montserrat', sans-serif
  font-size: 14px
  font-weight: 400
  text-overflow: ellipsis
  border: none
  border-radius: 18px
  box-shadow: 0 6px 18px rgba(61, 128, 232, 0.3)
  background-color: #3d80e8
  color: white

.clickable
  cursor: pointer

.content
  font-weight: 400

span
  word-break: keep-all
  word-wrap: break-word

.smaller-heading
  font-weight: 400!important
  font-size: 16px

.smallerline
  line-height: 1.4rem

.thin
  font-weight: 300!important
  letter-spacing: 1.6px

.header--blue
  color: #3d80e8!important

h4
  color: #243049!important

/* hides the x image */
button.gm-ui-hover-effect > span
  display: none !important

.gm-style-iw-chr
  display: none

.gm-style-iw-d
  padding-top: 10px
  justify-content: center!important
  align-content: center!important

.gm-style-iw-c
  padding: 10px
  justify-content: center!important
  align-content: center!important

/* Nested (secondary) category buttons - distinct from primary blue */
.child-menu-button
  border-left: 4px solid #3d80e8
  border-radius: 8px !important
  box-shadow: none !important
  transition: background-color 150ms ease, transform 150ms ease

.child-menu-button:hover
  background-color: #dce8fc !important
  transform: translateX(2px)

.child-menu-button--active
  border-left-color: #c8860f

.child-menu-button--active:hover
  background-color: #eba614 !important

.child-menu-text
  color: #23508f !important
  font-weight: 500 !important

/* Result cards - improved readability & hierarchy */
.side-card
  border-radius: 14px !important
  border: 1px solid #e4ebf6

.side-card .v-card__title
  padding-bottom: 4px

.side-card .smaller-heading
  font-weight: 700 !important
  font-size: 17px
  color: #2b6cd9 !important
  line-height: 1.45rem

.side-card .v-card__text
  color: #313f57 !important
  font-size: 14px
  line-height: 1.55

.side-card .v-card__text h4
  color: #7181a0 !important
  text-transform: uppercase
  font-size: 11px
  font-weight: 700 !important
  letter-spacing: 0.9px
  margin-top: 14px
  margin-bottom: 2px

.side-card .v-card__text a
  color: #2b6cd9
  font-weight: 600
  text-decoration: none

.side-card .v-card__text a:hover
  text-decoration: underline
</style>
